import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TableSearch from "../TableSearch";
import { API_URL, REPORTS_API_URL } from "../../constants/Globals";
import { numFormatter } from "../../helpers/Number";
import InfiniteScroll from "react-infinite-scroll-component";
import { ChevronDownIcon, ChevronUpIcon } from "../../icons";

const SuggestedSegmentsTableView = ({
  tableData = [],
  cellTag = () => {},
  hasMoreData = false,
  ageKey = "suggested-segments",
  sortDirection = "desc",
  sortByColumn = "",
  onSortChange,
  tableRowsTotal = {},
  onBackClick,
  onLoadMore,
  slugify,
  name = "",
  handleSuggestedSegmentsSave,
}) => {

  const getColumnTypeName = (slug) => slug;
  const allStatSumCols = [];
  const selectedColumnTypes = [
      "Name",
      "Tags",
      "Growth",
      "Anonymous Users",
      "Known Users",
      "Created Date",
      "#"
    ];

  const numberColumns = ["Anonymous Users", "Known Users"];

  function getCellValue(row, selectedColumnType) {
    if (selectedColumnType === 'Tags') {
      return row.tags ? row.tags.map(tag => tag.value).join(", ") : "";
    } else if (numberColumns.includes(selectedColumnType)) {
      return numFormatter(parseInt(row[slugify(selectedColumnType)]));
    } else if (selectedColumnType === 'Created Date') {
        return moment.utc(row[slugify(selectedColumnType)]).format("MMM DD, YYYY");
    } else if (selectedColumnType === '#') {
      return (
        <button
          className="blue-button"
          onClick={() => handleSuggestedSegmentsSave(row)}
        >
          Save
        </button>
      );
    }
    return row[slugify(selectedColumnType)] || "";
  }

  return (
    <div className="table-box">
      <div className="table-box-content">
        <InfiniteScroll
          dataLength={tableData.length} // Length of data loaded so far
          next={onLoadMore} // Function to fetch more data
          hasMore={hasMoreData} // Boolean to indicate if more data can be loaded
          loader={
            <h6 className="txtCenter infinite-loading">Loading more...</h6>
          } // Loader to display while fetching data
        >
          <table cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                {selectedColumnTypes.map((selectedColumnType) => (
                  <th
                    key={selectedColumnType}
                    onClick={() => {
                      if (onSortChange) {
                        onSortChange(
                          selectedColumnType,
                          selectedColumnType === sortByColumn &&
                            sortDirection === "desc"
                            ? "asc"
                            : "desc"
                        );
                      }
                    }}
                  >
                    {/* {getColumnTypeName(selectedColumnType)} // to display all column names in header*/}
                    {selectedColumnType === "#" ? "" : getColumnTypeName(selectedColumnType)}
                    {/* {sortByColumn === selectedColumnType ? (
                      <>
                        {sortDirection === "desc" ? (
                          <ChevronUpIcon />
                        ) : (
                          <ChevronDownIcon />
                        )}
                      </>
                    ) : null} */}
                  </th>
                ))}
              </tr>

              <tr className="totals-row">
                {selectedColumnTypes.map((selectedColumnType, index) => (
                  <td className="txtLeft" key={selectedColumnType}>
                    {allStatSumCols.includes(selectedColumnType)
                      ? getCellValue(
                          tableRowsTotal,
                          slugify(selectedColumnType)
                        )
                      : ""}
                  </td>
                ))}
              </tr>

              {tableData.length > 0 &&
                tableData.map((row, idx) => (
                  <tr key={`${row.segment_id}_${idx}`}>
                    {selectedColumnTypes.map((selectedColumnType, index) => (
                      <td key={selectedColumnType}>
                        <span>{getCellValue(row, selectedColumnType)}</span>
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>
  );
};


function Segments({ selNetworkId }) {
  const [state, setState] = useState(1);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("date");
  const [isSuggestedSegments, setIsSuggestedSegments] = useState(0);
  const [selectedSegmentType, setSelectedSegmentType] = useState("savedSegments");
  const [savedSegments, setSavedSegments] = useState([]);
  const [suggSegmentsTableData, setSuggSegmentsTableData] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [exportedSegment, setExportedSegment] = useState(0);
  const [sortByColumnMain, setSortByColumnMain] = useState("created_at");
  const [sortDirectionMain, setSortDirectionMain] = useState("desc");
  const [hasMoreData, setHasMoreData] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    if (selNetworkId) {
      axios
          .get(API_URL + "/admin/client/" + selNetworkId)
          .then((res) => {
            setIsSuggestedSegments(res.data.data.isSuggestedSegments ? 1 : 0);
          })
          .catch((err) => {
            console.log(err.response.data.message);
          });
    }
  }, [selNetworkId]);

  useEffect(() => {
    if (selNetworkId) {
      axios
        .get(`${API_URL}/admin/segments?clientId=${selNetworkId}`)
        .then(({ data }) => setSavedSegments(data.data));
    }
  }, [selNetworkId, state, selectedSegmentType]);

  useEffect(() => {
    const delay = setTimeout(() => {
      setSuggSegmentsTableData([]);
      setPageNumber(1);
      fetchSuggestedSegments(1);
    }, 400);

    return () => clearTimeout(delay);
  }, [selNetworkId, state, selectedSegmentType, search]);

  const fetchSuggestedSegments = async (page = 1) => {
    if (!selNetworkId) return;

    try {
      const { data } = await axios.get(
        `${REPORTS_API_URL}/tag-analytics/suggested-segments`,
        {
          params: {
            client_id: selNetworkId,
            week_start: '',
            page, // send page number
            per_page: 20, // optional: items per page
            search: search || undefined,
          },
        }
      );

      if (data?.data?.segments?.length > 0) {
        // append new data for infinite scroll
        setSuggSegmentsTableData((prev) => [...prev, ...data.data.segments]);
        setHasMoreData(true); // assume more data exists
      } else {
        setHasMoreData(false); // no more data
      }
    } catch (err) {
      console.error("Error fetching suggested segments:", err);
      setHasMoreData(false);
    }
  };

  const handleSuggestedSegmentsSave = async (sugSegData) => {
    console.log('Save button clicked', sugSegData);
    if (sugSegData.segment_id) {
      await axios
      .post(
        `${REPORTS_API_URL}/tag-analytics/segments/${sugSegData.segment_id}/save`,
        {alias: sugSegData.name}
      )
      .then((res) => {
        alert('Suggested segment saved successfully!');
      })
      .catch((err) => {
        alert(`Error in suggested segment save: ${err.response?.data?.message[0].error}`);
      });
    } else {
      alert('Suggested segment id missing!.');
    }
  }

  return (
    <div className="segments">
      <div className="page-headline is-flex">
        <div>
          <strong>Audience</strong>&nbsp;|&nbsp;Segments
        </div>
        <Link to="/audience/segments/new" className="blue-button size-l">
          Create Segment
        </Link>
      </div>

      <div className="segment-table-filters">
        <TableSearch
          value={search}
          placeholder="Search for segment"
          onChange={(value) => setSearch(value)}
        />

        <div className="table-filters">
          {/* <label className="label">Select Segment</label> */}
          <select
            id="segment-select-type"
            value={selectedSegmentType || ""}
            onChange={(e) => setSelectedSegmentType(e.target.value)}
            className="segment-select-type"
          >
            <option value="savedSegments">Saved Segments</option>
            {isSuggestedSegments && (
                <option value="suggestedSegments">Suggested Segments</option>
            )}
          </select>
        </div>
      </div>
      
      { selectedSegmentType === 'savedSegments' && (
        <>
          <div className="table-filters sorting">
            <div className="table-filters-start">
              <div className="table-sorter">
                <label>Sort by</label>
                <select
                  value={sortBy}
                  onChange={({ target }) => setSortBy(target.value)}
                >
                  <option value="date">Most Recent</option>
                  <option value="name">Name</option>
                </select>
              </div>
            </div>

            <div className="table-pagination">{savedSegments.length} Segments</div>
              </div>
              <div className="table-wrapper">
            <table
              className="table-body top-border"
              cellSpacing="0"
              cellPadding="0"
            >
              <tbody>
                {savedSegments
                  .sort((a, b) => {
                    if (sortBy === "date") {
                      return moment(a.createdAt) < moment(b.createdAt) ? 1 : -1;
                    }

                    return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
                  })
                  .filter(
                    ({ name }) =>
                      !search ||
                      name.toLowerCase().indexOf(search.toLowerCase().trim()) !==
                        -1,
                  )
                  .map(({ id, name, userCount, createdAt }) => (
                    <tr key={id} className="table-row">
                      <td className="table-cell table-cell-fluid">
                        <Link
                          to={`/audience?segment=${id}`}
                          className="text-button inherit-font"
                        >
                          {name}
                        </Link>
                      </td>
                      <td className="table-cell table-cell-labelled" width="120">
                        <div>
                          People
                          <br />
                          <strong>{userCount}</strong>
                        </div>
                      </td>
                      <td className="table-cell table-cell-labelled" width="150">
                        <div>
                          Created
                          <br />
                          <strong>{moment(createdAt).format("MMM DD, Y")}</strong>
                        </div>
                      </td>
                      <td className="table-cell table-action" width="280">
                        <div className="inline-buttons">
                          <Link
                            to={`/audience/segments/${id}`}
                            className="blue-button bordered"
                          >
                            Edit
                          </Link>
                          {userCount > 0 ? (
                            <button
                              className="blue-button bordered"
                              onClick={() => {
                                if (!exportedSegment) {
                                  setExportedSegment(id);
                                  axios
                                    .get(
                                      `${API_URL}/admin/segments/${id}?clientId=${selNetworkId}&csv=1`,
                                    )
                                    .then(({ data }) => {
                                      const { link } = data.data;
                                      setReportData(link);
                                      setExportedSegment(0);
                                    });
                                }
                              }}
                            >
                              {exportedSegment === id
                                ? "Please wait..."
                                : "Export As CSV"}
                            </button>
                          ) : null}
                          <button
                            className="blue-button bordered"
                            onClick={() => {
                              if (window.confirm("Are you sure?")) {
                                axios
                                  .delete(
                                    `${API_URL}/admin/segments/delete/${id}?clientId=${selNetworkId}`,
                                  )
                                  .then(() => setState(state * 2));
                              }
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {reportData ? (
            <div className="modal-cta">
              <div className="modal-cta-inner">
                <h3>The export was successfully generated</h3>
                <div className="modal-cta-buttons">
                  <button
                    className="blue-button bordered"
                    onClick={() => setReportData(null)}
                  >
                    Close
                  </button>
                  <a
                    href={reportData}
                    className="blue-button"
                    onClick={() => setReportData(null)}
                  >
                    Download
                  </a>
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}

      { selectedSegmentType === 'suggestedSegments' && (
        <>
          <div>
            <SuggestedSegmentsTableView
              name="suggested-segments"
              dateFormat="MMMM Y"
              tableData={suggSegmentsTableData}
              tableRowsTotal={{ totalResponses: 7890 }}
              ageKey="suggested-segments"
              sortByColumn={sortByColumnMain}
              sortDirection={sortDirectionMain}
              hasMoreData={hasMoreData}
              columnTypes={[
                "Name",
                "Tags",
                "Growth",
                "Anonymous Users",
                "Known Users",
                "Created Date",
                "#"
              ]}
              cellTag={() => {}}
              handleSuggestedSegmentsSave = {(sugSeg) => handleSuggestedSegmentsSave(sugSeg)}
              slugify={(name) =>
                name
                  .trim()
                  // .split(" ")
                  // .map((piece, index) => (index === 0 ? piece.toLowerCase() : piece))
                  // .map((piece, index) =>
                  //   index === 0
                  //     ? piece.charAt(0).toLowerCase() + piece.slice(1)
                  //     : piece
                  // )
                  // .join("")
                  .replace("Name", "name")
                  .replace("Growth", "growth_rate")
                  .replace("Anonymous Users", "unique_anon_users")
                  .replace("Known Users", "unique_known_users")
                  .replace("Created Date", "created_at")
              }
              onSortChange={(column, direction) => {
                setSortByColumnMain(column);
                setSortDirectionMain(direction);
              }}
              onLoadMore={() => {
                const newPage = pageNumber + 1;
                setPageNumber(newPage);
                fetchSuggestedSegments(newPage);
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(Segments);
